import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { setAlarmsMutedCountdownStart, setAlarmsLeftPage } from "services/redux/actions/alarmResponse";

const CountdownTimer = ({ muted, muteClick }) => {
  const dispatch = useDispatch();

  const [timeRemaining, setTimeRemaining] = useState(0);

  const countdownStart = useSelector((state) => state.alarmResponse.countdownStart);
  const leftPage = useSelector((state) => state.alarmResponse.leftPage);

  const timerValue = 600000;

  useEffect(() => {
    // initital render
    const currentTime = new Date().getTime();
    const timeSinceCountdownStart = Math.ceil(((currentTime - countdownStart) + 1) / 1000) * 1000; // round to nearest 1000ms
    if (timeSinceCountdownStart < timerValue ) { // there's still time left on the timer
      setTimeRemaining(timerValue - timeSinceCountdownStart);
    } else {
      if (muted) { // no time left on the timer, so if it's muted, unmute it
        muteClick();
      }
    }
  }, []);

  useEffect(() => {
    // monitoring changes in 'muted'
    if (muted) { // 'muted' has changed to true
      if (leftPage) { // if the user has left the page and come back, don't do anything except switch the leftPage flag off
        dispatch(setAlarmsLeftPage({ 
          leftPage: false,
        }));
      } else { // user had clicked the mute button, so start the timer
        setTimeRemaining(timerValue);
        dispatch(setAlarmsMutedCountdownStart({ 
          countdownStart: new Date().getTime(),
        }));
      }
    } else { // 'muted' has changed to false
      setTimeRemaining(0);
      dispatch(setAlarmsMutedCountdownStart({ 
        countdownStart: null,
      }));

      if (leftPage) {
        dispatch(setAlarmsLeftPage({ 
          leftPage: false,
        }));
      }
    };
  }, [muted]);

  useEffect(() => {
    // monitoring changes in 'timeRemaining'
    if (timeRemaining === 0 && muted && !leftPage) {
      muteClick();
    }

    let timer = setTimeout(() => {
      setTimeRemaining((timeRemaining) => {
        if (timeRemaining === 0) {
          clearTimeout(timer);
          return 0;
        } else return timeRemaining - 1000;
      });
    }, 1000);

    return () => {
      clearTimeout(timer);
    }
  }, [timeRemaining]);

  useEffect(() => {
    // unmount
    return () => {
      dispatch(setAlarmsLeftPage({ 
        leftPage: true,
      }));
    }
  }, []);

  return (
    <div style={{fontSize: "0.7rem", height: "0.7rem"}}>
      {timeRemaining > 0 && `${Math.floor(timeRemaining / 60000)}`.padStart(2, 0) + ":" + `${(timeRemaining % 60000)/1000}`.padStart(2, 0)}
    </div>
  );
};

export default CountdownTimer;